export const week = {
  week: 'Semaine',
  current_week: 'Semaine en cours',
  type_week: 'Semaine type',
};
